<template>
  <div class="home">
      
    <div class="gridCard">

      <div class="landingContent">
        <h1><span>You got the idea.</span> <span>My job is making it reality.</span></h1>
        <p>
          I am a software developer <span>specialized but not limited to Web Development</span>, which means I can build your website or web application, 
          create APIs that deliver content to your sites or applications for users worldwide.
        </p>

        <p>
          I started programming in 2013 when I was in high school, and later I enrolled in a university to become an engineer. In 2020 I 
          finished the university studies program but I kept studying Software Development, and now it is my job.
        </p>
<!--         <p>
          Being an IT professional is not only about having advanced computing knowledge, it's also about helping people make good decisions. 
          You know what you want, but you don't have any idea of how you can get it? That's it, <span>I can surely have something to tell you about 
          your doubts.</span>
        </p> -->

        <h4 :style="{ margin: '0 auto 5px auto' }">My core technologies:</h4>
        <div class="coreTech">
            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/JavaScript.png" alt="js">
              <p>JavaScript (Vanilla)</p>
            </div>

            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/node.png" alt="nodejs">
              <p>NodeJS</p>
            </div>

            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/vue.png" alt="vuejs">
              <p>VueJS</p>
            </div>

            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/mongodb.png" alt="mongodb">
              <p>MongoDB</p>
            </div>

            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/csharp.png" alt="net-framwork">
              <p>.NET Framework/Core (C#)</p>
            </div>

            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/sqlserver.png" alt="sqlserver">
              <p>SQL Server</p>
            </div>

            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/hypertext.png" alt="html">
              <p>HTML</p>
            </div>

            <div>
              <img src="https://showroom.nethanzel.dev/img/skills/css.png" alt="css">
              <p>CSS</p>
            </div>
        </div>


        <div class="infoFooter">
          <h4 :style="{margin:'0 0 10px 0'}">Are you interested?</h4>

          <div class="cvOptions">

            <div class="download" ref="cvDownload">
              <div @click="showCVOptions()">
                <i class="icofont-cloud-download"></i>
                <p>Download my CV</p>
              </div>

              <div @click="openLink_('https://showroom.nethanzel.dev/contact', '_self')">
                <i class="icofont-envelope"></i>
                <p>Get in touch</p>
              </div>

            </div>

            <div class="options" ref="cvOptions">

              <div @click="openLink_('https://showroom.nethanzel.dev/docs/cv/nethanzels_cv.pdf' , '_blank')">
                <i class="icofont-file-pdf"></i>
                <p>English document</p>
              </div>

              <div @click="openLink_('https://showroom.nethanzel.dev/docs/cv/nethanzels_cv_sp.pdf', '_blank')">
                <i class="icofont-file-pdf"></i>
                <p>Documento en español</p>
              </div>

            </div>
          </div>
          <!--  -->

          <div class="more">
            <h4>Have a look to...</h4>
            <div class="options">
              <div @click="openLink_('https://showroom.nethanzel.dev/', '_self')">
                <i class="icofont-ui-note"></i>
                <p>Résumé</p>
              </div>

              <div @click="openLink_('https://showroom.nethanzel.dev/experience', '_self')">
                <i class="icofont-badge"></i>
                <p>My experience</p>
              </div>

              <div @click="openLink_('https://showroom.nethanzel.dev/projects', '_self')">
                <i class="icofont-rulers-alt"></i>
                <p>My projects</p>
              </div>

              <div @click="openLink_('https://showroom.nethanzel.dev/about', '_self')">
                <i class="icofont-ui-user"></i>
                <p>About me</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="imgFlow">
        <div>
          <div class="aureola" ref="exTarget">
            <!-- <img src="../assets/01.png" alt="nethenzel" /> -->
            <img src="../assets/02.png" alt="nethenzel" />
            <!-- <img src="../assets/03.png" alt="nethenzel" /> -->
          </div>
        </div>
        <h1>Félix Natanael Abad</h1>
        <p :style="{marginBottom:'7px'}">Systems and Computing engineer focused on Software Development.</p>
        <p :style="{ display: 'flex' }">From <img src="../assets/doflag.png" alt="doflag" :style="{ width: '25px', height: '17px', margin: '0 4px' }"> Dominican Republic.</p>
      </div>

      <Footer class="footer" />

    </div>
  </div>
</template>

<script>
  import Footer from "../components/Footer.vue";

  export default {
    name: 'Home',
    title: "Nethanzêl",
    components: {
      Footer
    },
    mounted() {
      //this.imageExchange();
    },
    methods: {
      imageExchange() {
        let container = this.$refs.exTarget;
        let imgCollection = container.getElementsByTagName("img");
        
        let index = 0;
        let beforeIndex = 0;

        for(let image of imgCollection) {
          if(index == 0) {
            index = 1; 
            continue;
          }
          image.style.opacity = 0;
        }

        setInterval(() => {
          
          imgCollection[index].style.opacity = 1;

          if(beforeIndex != undefined) imgCollection[beforeIndex].style.opacity = 0;

          beforeIndex = index;
          index = index+1;

          if(index > imgCollection.length -1) index = 0;
        }, 5000);

      },
      showCVOptions() {
        this.$refs.cvDownload.style.display = "none";
        this.$refs.cvOptions.style.display = "flex";
        setTimeout(() => {
          this.$refs.cvDownload.style.display = "flex";
          this.$refs.cvOptions.style.display = "none";
        }, 15000);
      },
      openLink_(url, target) {
        console.log(target);
        window.open(url, target);
      }
    }
  }
</script>

<style lang="scss" scoped>

.home {
  width: 100vw;
  height: 100vh;
  max-width: 90%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
}

.gridCard {
  height: 100vh;
  max-height: 850px;

  display: grid;
  grid-template-columns: 50% 50%;
  //grid-template-rows: 40% 36% 14%;
  grid-template-areas: 'flow con'
                       'flow con'
                       'foo foo';
  grid-gap: 5px;
  margin: 30px 0 0 0;

  .landingContent {
    grid-area: con;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0 0 0 5px;
    
    h1 {
      margin: 0px 0 20px 0;
      font-size: 50px;

      span:nth-child(1) {
        display: block;
      }
    }

    p {
      margin: 0 auto 20px auto;
      text-align: left;
      line-height: 23px;
      //max-width: 95%;

      span {
        background-color: rgb(255, 255, 255);
        color: #000;
        font-weight: bold;
        padding: 1px 3px;
      }
    }

    .coreTech {
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      pointer-events: none;
      user-select: none;
      margin-bottom: 5px;
      div {
        display: flex;
        align-items: center;
        margin: 3px 5px;
        padding: 3px 8px;
        background-color: #ffffffab;
        img {
          height: 25px;
          margin: 0 8px 0 0;
        }
        p {
          font-size: 13px;
          color: #000;
          margin: 0;
        }
      }
    }
  }

  .imgFlow {
    grid-area: flow;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h1 {
      font-size: 45px;
      letter-spacing: 2px;
    }

    div {
      background-color: rgb(255, 255, 255);
      border-radius: 50%;
      overflow: hidden;
      display: flex;

      align-items: flex-end;
      justify-content: center;
      min-height: 500px;
      max-height: 500px;

      min-width: 500px;
      max-width: 500px;
      .aureola {
        position: relative;
        overflow: visible;
        background-color: rgb(25, 25, 25);
        height: 450px;
        width: 450px;
        top: 150px;

        img {
          position: absolute;
          height: 500px;
          width: 500px;
          object-fit: scale-down;
          transition: 0.3s;
          filter: drop-shadow(0.7rem -0.2rem 0rem black) 
                  drop-shadow(-0.5rem -0.5rem 0rem black);
          top: -140px;
        }
      }
    }
  }

  .infoFooter {
    height: 215px;
    //max-height: 150px;
    width: auto;
    width: 100%;
    padding: 0 0 10px 0;
    margin: 0px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .cvOptions {
      max-height: 60px;
      width: 100%;
      display: flex;
      justify-content: center;
      overflow: hidden;
      margin: 0 0 5px 0;
      .download {
        display: flex;
        justify-content: center;
        width: 100%;

        p {
          font-size: 13px;
          cursor: pointer;
          margin-top: -2px;
          margin: 0;
          color: #000;
        }

        i {
          font-size: 23px;
          margin: 0 8px 0 0;
          color: #000;
        }

        div {
          display: flex;
          align-items: center;
          margin: 0px 15px;
          padding: 5px 9px;
          border-radius: 3px;
          cursor: pointer;
          background-color: #ffffff9d;
          height: 25px;
          transition: background-color .4s;
          &:hover {
            //filter: invert(.5);
            background-color: #fff;
          }
        }

      }
      .options {
        display: none;
        width: 70%;
        justify-content: center;
        
        p {
          font-size: 13px;
          cursor: pointer;
          margin: 0;
          color: #000;
          overflow: hidden;
          white-space: nowrap;
        }

        i {
          font-size: 23px;
          margin: 0 6px 0 0;
          color: #000;
        }

        div {
          display: flex;
          align-items: center;
          margin: 0px 25px;
          padding: 5px 9px 5px 9px;
          border-radius: 3px;
          background-color: #ffffff9d;
          width: 185px;
          height: 25px;
          cursor: pointer;
          transition: background-color .4s;
          &:hover {
            background-color: #fff;
          }
        }
      }
    }

    .more {
      margin: 10px auto 0 auto;
      width: 70%;
      height: auto;

      .options {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        div {
          display: flex;
          align-items: center;
          margin: 10px;
          max-width: 135px;
          padding: 5px 9px;
          border-radius: 3px;
          background-color: #ffffff9d;
          height: 25px;
          cursor: pointer;
          transition: background-color .4s;
          p {
            margin: 0;
            font-size: 13px;
            color: #000;
          }
          i {
            margin: 0 8px 0 0;
            font-size: 23px;
            color: #000;
          }
          &:hover {
            background-color: #fff;
          }
        }

      }

      h2 {
        font-size: 20px;
      }
    }
  }

  .footer {
    grid-area: foo;
  }

}

@media screen and (max-width: 1445px) {
  .gridCard {
    grid-template-columns: 55% 45;
  }
}

@media screen and (max-width: 1370px) {
  .home {
    max-width: 98%;
  }

  .gridCard {
    max-height: 800px;
    min-height: unset;

    .landingContent {
      
      h1 {
        font-size: 50px;
      }

      p {
        font-size: 14px;
        line-height: 22px;
      }

    }

    .imgFlow {

      h1 {
        font-size: 44px;
        letter-spacing: 2px;
      }

      p {
        font-size: 15px;
      }

      div {

        min-height: 500px;
        max-height: 500px;

        min-width: 500px;
        max-width: 500px;

        .aureola {
          height: 550px;
          width: 550px;
          top: 80px;

          img {
            height: 500px;
            width: 500px;
            top: -70px;
          }
        }
      }
    }

    .infoFooter {
      h2 {
        font-size: 19px;
      }

    }
  }
}

@media screen and (max-width: 1285px) {
  .home {
    max-width: 98%;
  }

  .gridCard {
    .landingContent {
      
      h1 {
        font-size: 40px;
      }

      p {
        font-size: 14px;
        line-height: 22px;
        //max-width: 95%;
      }

    }

    .imgFlow {

      h1 {
        font-size: 40px;
        letter-spacing: 2px;
      }

      p {
        font-size: 14px;
      }

      div {

        min-height: 450px;
        max-height: 450px;

        min-width: 450px;
        max-width: 450px;

        .aureola {
          height: 500px;
          width: 500px;
          top: 80px;

          img {
            height: 450px;
            width: 450px;
            top: -70px;
          }
        }
      }
    }

  }
}

@media screen and (max-width: 1090px) {
  .gridCard {
    max-height: 770px;
    .landingContent {
      
      h1 {
        font-size: 40px;
      }

      p {
        font-size: 14px;
        line-height: 22px;
        //max-width: 95%;
      }

    }

    .imgFlow {

      h1 {
        font-size: 40px;
        letter-spacing: 2px;
      }

      p {
        font-size: 14px;
      }

      div {

        min-height: 400px;
        max-height: 400px;

        min-width: 400px;
        max-width: 400px;

        .aureola {
          height: 450px;
          width: 450px;
          top: 80px;

          img {
            height: 400px;
            width: 400px;
            top: -70px;
          }
        }
      }
    }

    .infoFooter {
      .more {
        width: 100%;
      }
    }

  }
}

@media screen and (max-width: 930px) {
  .gridCard {
    grid-template-areas: 'flow flow'
                        'con con'
                        'foo foo';
    .landingContent {
      width: 99%;
      margin: 35px 0 25px 0;

      h1 {
        font-size: 47px;
        margin-bottom: 30px;
      }

      p {
        max-width: 93%;
        font-size: 15px;
        margin: 0 auto 15px auto;
      }

    }

    .imgFlow {
      margin-top: 6vh;
      padding: 15px 0px;
      width: 99%;
      h1 {
        font-size: 45px;
        letter-spacing: 2px;
      }

      div {
        min-height: 500px;
        max-height: 500px;

        min-width: 500px;
        max-width: 500px;
        .aureola {
          height: 450px;
          width: 450px;
          top: 150px;

          img {
            position: absolute;
            height: 500px;
            width: 500px;
            top: -140px;
          }
        }
      }
    }

  }

  .home {
    margin: 0;
    max-width: 100%;
  }
}

@media screen and (max-width: 515px) {
  .gridCard {

    .imgFlow {

      div {
        min-height: 400px;
        max-height: 400px;

        min-width: 400px;
        max-width: 400px;
        .aureola {
          height: 350px;
          width: 350px;

          img {
            height: 400px;
            width: 400px;
          }
        }
      }
    }

    .infoFooter {
      height: 245px;
      padding: 5px 0;
    .cvOptions {
      max-height: unset;
      .download {
        display: flex;
        justify-content: center;
        width: 100%;
      }
      .options {
        display: none;
        flex-direction: column;
        div {
          margin: 8px auto;
        }
      }
    }
  }

  }
}

@media screen and (max-width: 450px) {
  .cvOptions {
    .options {
      display: none;
      width: 100%;
      div {
        margin: 0 10px;
        width: 50%;
      }
    }
  }
  .gridCard {
    .imgFlow {
      h1 {
        font-size: 40px;
      }
    }
  }
}

@media screen and (max-width: 410px) {
  .gridCard {

    .imgFlow {
      h1 {
        font-size: 35px;
      }

      div {
        min-height: 350px;
        max-height: 350px;

        min-width: 350px;
        max-width: 350px;
        .aureola {
          height: 300px;
          width: 300px;

          img {
            height: 350px;
            width: 350px;
          }
        }
      }
    }
    .landingContent {
      h1 {
        font-size: 40px;
      }
    }
  }
}

</style>